{
  "title": "如何從匯出中心匯出報表",
  "description": "在匯出中心選擇報表種類、欄位與篩選條件，下載 CSV 或轉換為 XLSX。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "完成後，您能下載指定報表的 CSV 或 XLSX 檔案，並在同一頁查看每一次匯出的稽核紀錄。",
  "roleNote": "競賽管理員／具對應資料檢視權限的工作人員（評分與審查意見報表需 score.read）",
  "prerequisites": [
    "競賽已建立",
    "該報表對應的資料已存在（例如尚無隊伍時，隊伍報表僅會匯出空白表頭）"
  ],
  "pathLabel": "主辦方後台 → 我的競賽 → 資料 → 匯出中心",
  "steps": [
    {
      "title": "1. 開啟匯出中心",
      "description": "進入指定競賽後，點選「資料」分組下的「匯出中心」。"
    },
    {
      "title": "2. 選擇報表種類",
      "description": "頁面提供隊伍、作品、參賽者、資格驗證、報名資料、評審、評分與審查意見共 7 種報表，各自獨立一張卡片。「評分與審查意見」每位評審對每件作品一列（輪次、類別、隊伍、作品 ID、評審、狀態、總分、各項分數、審查意見、送出時間），只含已送出的評分，需具備評分查看權限（score.read），競賽管理員與工作人員皆具備。"
    },
    {
      "title": "3. 選擇欄位（可選）",
      "description": "每張卡片預設勾選該報表的所有欄位，可取消勾選不需要的欄位；至少須勾選一個欄位才能匯出。單張報表最多匯出 50,000 列，超過時會提示以篩選縮小範圍。"
    },
    {
      "title": "4. 套用目前篩選條件（可選）",
      "description": "資格驗證與報名資料兩種報表支援勾選「套用目前篩選條件」，可依狀態、隊伍、關鍵字等條件縮小匯出範圍；隊伍、作品、參賽者、評審、評分與審查意見報表目前不提供篩選，一律匯出全部資料列。"
    },
    {
      "title": "5. 確認匯出範圍",
      "description": "在下載按鈕之前，每張卡片會即時顯示「將匯出 N 筆」（依目前欄位與篩選條件查詢）與「目前篩選：...」摘要（無篩選時顯示「無」）；下載前先看一眼這裡，確認範圍符合預期再點擊下載，這個筆數查詢本身不會被記錄為一次匯出。"
    },
    {
      "title": "6. 下載 CSV 或轉換為 XLSX",
      "description": "點選「下載 CSV」直接取得原始 CSV 檔案，或點選「轉換為 XLSX」在瀏覽器端將同一份資料轉存為 Excel 檔案；兩者資料內容相同，差別僅在檔案格式。"
    }
  ],
  "afterward": [
    "下載的檔案會出現在您的瀏覽器下載資料夾",
    "資格驗證與報名資料報表刻意不包含證明檔案本體、私有物件金鑰、簽章網址，或表單原始填答內容",
    "評分與審查意見報表只含提供給主辦方的審查意見，永遠不含評審的私人評分備註，也不含草稿與重新開放中的分數",
    "本次匯出（連同既有的隊伍與作品匯出）會立即出現在同一頁「匯出紀錄」，記錄操作者、報表種類、篩選條件、筆數與時間"
  ],
  "nextSteps": "若需要定期匯出同一份報表，建議記下目前選擇的欄位與篩選條件，下次操作時重新套用即可，系統目前不提供儲存範本功能。",
  "faq": [
    {
      "q": "為什麼資格驗證與報名資料報表看不到證明檔案或表單原始內容？",
      "a": "這是刻意的設計：這兩種報表的允許欄位清單本來就不包含證明檔案本體、私有物件金鑰、簽章網址或表單原始填答內容，伺服器端也會獨立驗證，即使直接呼叫 API 也無法取得。"
    },
    {
      "q": "匯出紀錄會保留多久？可以刪除嗎？",
      "a": "匯出紀錄與其他稽核紀錄一樣唯讀保存，不提供刪除或修改功能；每一次成功匯出都會留下操作者、報表種類、篩選條件、筆數與時間。"
    },
    {
      "q": "「將匯出 N 筆」的即時查詢會不會也被記在匯出紀錄裡？",
      "a": "不會。這個筆數查詢刻意不寫入稽核紀錄，只有真正點擊「下載 CSV」或「轉換為 XLSX」的動作才會出現在「匯出紀錄」裡，避免您調整篩選時的每一次即時查詢被誤記成一次次的匯出事件。"
    }
  ]
}
